import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
export var AppliedCouponsFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment AppliedCouponsFragment on Cart {\n        id\n        applied_coupons {\n            code\n        }\n    }\n"])));